import * as yup from "yup";

const today = new Date();
today.setHours(0, 0, 0, 0);

const fleetFormSchema = yup.object().shape({
  vehicleType: yup.string().trim().test('not-empty', 'Vehicle Type cannot be empty', val => !!val && val.trim().length > 0).required("Vehicle Type is required"),
  model: yup.string().trim().test('not-empty', 'Model cannot be empty', val => !!val && val.trim().length > 0).required("Model is required"),
  manufacturer: yup.string().trim().test('not-empty', 'Manufacturer cannot be empty', val => !!val && val.trim().length > 0).required("Manufacturer is required"),
  year: yup
    .number()
    .typeError("Year must be a number")
    .integer("Year must be an integer")
    .min(1900, "Year must be after 1900")
    .max(new Date().getFullYear(), "Year cannot be in the future")
    .required("Year is required"),
  regEndDate: yup.date().required("Registration End Date is required"),
  vehicleColor: yup.string().trim().test('not-empty', 'Vehicle Color cannot be empty', val => !!val && val.trim().length > 0).required("Vehicle Color is required"),
  seatingCapacity: yup
    .number()
    .typeError("Seating Capacity must be a number")
    .integer("Seating Capacity must be an integer")
    .min(1, "Seating Capacity must be at least 1")
    .required("Seating Capacity is required"),
  fuelType: yup
    .string()
    .trim()
    .test('not-empty', 'Fuel Type cannot be empty', val => !!val && val.trim().length > 0)
    .oneOf(["petrol", "diesel", "electric", "cng"], "Invalid Fuel Type")
    .required("Fuel Type is required"),
  gpsTracking: yup.boolean().nullable(),
  registrationNumber: yup
    .string()
    .trim()
    .test('not-empty', 'Registration Number cannot be empty', val => !!val && val.trim().length > 0)
    .min(3, "Registration Number must be at least 3 characters")
    .required("Registration Number is required"),
  registrationFront: yup
    .string()
    .required("Registration Front Image is required"),
  registrationBack: yup
    .string()
    .required("Registration Back Image is required"),
  insuranceProvider: yup.string()
    .trim()
    .test('not-empty', 'Insurance Provider cannot be empty', val => !!val && val.trim().length > 0)
    .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces allowed")
    .min(2, "Provider name must be at least 2 characters")
    .max(50, "Provider name cannot exceed 50 characters")
    .required("Insurance provider is required"),

  policyNumber: yup.string()
    .trim()
    .test('not-empty', 'Policy Number cannot be empty', val => !!val && val.trim().length > 0)
    .matches(/^[A-Za-z0-9]+$/, "Policy number must be alphanumeric")
    .min(5, "Policy number must be at least 5 characters")
    .max(20, "Policy number cannot exceed 20 characters")
    .required("Policy number is required"),

  insuranceExpiryDate: yup.date()
    .typeError("Invalid date")
    .min(today, "Insurance expiry date cannot be in the past")
    .required("Insurance expiry date is required"),
  insuranceImage: yup
    .string()
    .required("Insurance Certificate Image is required"),

  fitnessEndDate: yup.date()
    .typeError("Invalid date")
    .required("Fitness end date is required"),

  fitnessCertificate: yup
    .string()
    .required("Fitness Certificate Image is required"),
  pucEndDate: yup.date()
    .typeError("Invalid date")
    .min(today, "PUC End Date cannot be in the past")
    .required("PUC End Date is required"),

  pucCertificate: yup.string().required("PUC Certificate Image is required"),

  permitEndDate: yup.date()
    .typeError("Invalid date")
    .min(today, "Permit End Date cannot be in the past")
    .max(
      new Date(today.getFullYear() + 5, today.getMonth(), today.getDate()),
      "Permit End Date cannot exceed 5 years from today"
    )
    .required("Permit End Date is required"),
  permitCertificate: yup
    .string()
    .required("Permit Certificate Image is required"),
  taxPaidTillDate: yup.date()
    .typeError("Invalid date")
    .min(today, "Tax Paid Till Date cannot be in the past")
    .required("Tax Paid Till Date is required"),

  taxDocument: yup.string().required("Tax Document is required"),
  vehicleImage: yup.string().required("Vehicle Image is required"),
  ownerType: yup
    .string()
    .oneOf(["driver", "vendor"], "Invalid Owner Type")
    .required("Owner Type is required"),
  ownerId: yup.string().required("Owner ID is required"),
  operationalStatus: yup
    .string()
    .oneOf(["in_review", "active", "inactive", "blacklisted"], "Invalid Operational Status")
    .required("Operational Status is required"),
  administrativeStatus: yup
    .number()
    .oneOf([0, 1, 2, 3], "Invalid Administrative Status")
    .required("Administrative Status is required"),
  vehicleNumber: yup.string()
    .trim()
    .test('not-empty', 'Vehicle Number cannot be empty', val => !!val && val.trim().length > 0)
    .min(5, "Vehicle number must be at least 5 characters")
    .max(15, "Vehicle number cannot exceed 15 characters")
    .required("Vehicle number is required"),
});

export default fleetFormSchema;
